export function hasDuplicates<T>(array: T[], keyExtractor: (item: T) => string): boolean {
  const counts = array.reduce(
    (acc, item) => {
      const key = keyExtractor(item);
      acc[key] = (acc[key] || 0) + 1;
      return acc;
    },
    {} as Record<string, number>,
  );

  return Object.values(counts).some((count) => count > 1);
}
